<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>

<ng-container *ngIf="loadInfo && form">
  <p class="text-info mb-sm">Ingresa los valores correspondientes a los datos bioquímicos</p>
  <form [formGroup]="form" novalidate nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="erythrocytes" [nzTooltipTitle]="'Valor de referencia: ' + form.get('erythrocytes').get('reference').get('min').value + ' a ' + form.get('erythrocytes').get('reference').get('max').value + ' ' + form.get('erythrocytes').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Eritrocitos
          <ng-container *ngIf="(form.get('erythrocytes') | getLevelBiochemical) as inferenceValue">
            <p *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('erythrocytes').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="hemoglobin" [nzTooltipTitle]="'Valor de referencia: ' + form.get('hemoglobin').get('reference').get('min').value + ' a ' + form.get('hemoglobin').get('reference').get('max').value + ' ' + form.get('hemoglobin').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Hemoglobina
          <ng-container *ngIf="(form.get('hemoglobin') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('hemoglobin').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="hematocrit" [nzTooltipTitle]="'Valor de referencia: ' + form.get('hematocrit').get('reference').get('min').value + ' a ' + form.get('hematocrit').get('reference').get('max').value + ' ' + form.get('hematocrit').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Hematocrito
          <ng-container *ngIf="(form.get('hematocrit') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('hematocrit').get('unit').value">
          <nz-input-number [nzMin]="0" [nzMax]="100" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="leukocytes" [nzTooltipTitle]="'Valor de referencia: ' + form.get('leukocytes').get('reference').get('min').value + ' a ' + form.get('leukocytes').get('reference').get('max').value + ' ' + form.get('leukocytes').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Leucocitos
          <ng-container *ngIf="(form.get('leukocytes') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('leukocytes').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="lymphocytes" [nzTooltipTitle]="'Valor de referencia: ' + form.get('lymphocytes').get('reference').get('min').value + ' a ' + form.get('lymphocytes').get('reference').get('max').value + ' ' + form.get('lymphocytes').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Linfocitos
          <ng-container *ngIf="(form.get('lymphocytes') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('lymphocytes').get('unit').value">
          <nz-input-number [nzMin]="0" [nzMax]="100" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="serum_creatinine" [nzTooltipTitle]="'Valor de referencia: ' + form.get('serum_creatinine').get('reference').get('min').value + ' a ' + form.get('serum_creatinine').get('reference').get('max').value + ' ' + form.get('serum_creatinine').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Creatinina serica
          <ng-container *ngIf="(form.get('serum_creatinine') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('serum_creatinine').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="serum_urea" [nzTooltipTitle]="'Valor de referencia: ' + form.get('serum_urea').get('reference').get('min').value + ' a ' + form.get('serum_urea').get('reference').get('max').value + ' ' + form.get('serum_urea').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Urea serica
          <ng-container *ngIf="(form.get('serum_urea') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('serum_urea').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="urea_nitrogen" [nzTooltipTitle]="'Valor de referencia: ' + form.get('urea_nitrogen').get('reference').get('min').value + ' a ' + form.get('urea_nitrogen').get('reference').get('max').value + ' ' + form.get('urea_nitrogen').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Nitrogeno de la urea
          <ng-container *ngIf="(form.get('urea_nitrogen') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('urea_nitrogen').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="uric_acid" [nzTooltipTitle]="'Valor de referencia: ' + form.get('uric_acid').get('reference').get('min').value + ' a ' + form.get('uric_acid').get('reference').get('max').value + ' ' + form.get('uric_acid').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Ácido urico
          <ng-container *ngIf="(form.get('uric_acid') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('uric_acid').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="sodium" [nzTooltipTitle]="'Valor de referencia: ' + form.get('sodium').get('reference').get('min').value + ' a ' + form.get('sodium').get('reference').get('max').value + ' ' + form.get('sodium').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Sodio
          <ng-container *ngIf="(form.get('sodium') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('sodium').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="potassium" [nzTooltipTitle]="'Valor de referencia: ' + form.get('potassium').get('reference').get('min').value + ' a ' + form.get('potassium').get('reference').get('max').value + ' ' + form.get('potassium').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Potasio
          <ng-container *ngIf="(form.get('potassium') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('potassium').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="calcium" [nzTooltipTitle]="'Valor de referencia: ' + form.get('calcium').get('reference').get('min').value + ' a ' + form.get('calcium').get('reference').get('max').value + ' ' + form.get('calcium').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Calcio
          <ng-container *ngIf="(form.get('calcium') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('calcium').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="chlorine" [nzTooltipTitle]="'Valor de referencia: ' + form.get('chlorine').get('reference').get('min').value + ' a ' + form.get('chlorine').get('reference').get('max').value + ' ' + form.get('chlorine').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Cloro
          <ng-container *ngIf="(form.get('chlorine') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('chlorine').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="serum_magnesium" [nzTooltipTitle]="'Valor de referencia: ' + form.get('serum_magnesium').get('reference').get('min').value + ' a ' + form.get('serum_magnesium').get('reference').get('max').value + ' ' + form.get('serum_magnesium').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Magnesio serico
          <ng-container *ngIf="(form.get('serum_magnesium') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('serum_magnesium').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="glucose" [nzTooltipTitle]="'Valor de referencia: ' + form.get('glucose').get('reference').get('min').value + ' a ' + form.get('glucose').get('reference').get('max').value + ' ' + form.get('glucose').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Glucosa
          <ng-container *ngIf="(form.get('glucose') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('glucose').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col
        nzXs="24"
        nzMd="24"
        nzLg="6" class="mb-sm d-flex flex-column justify-content-between" formGroupName="phosphorus" [nzTooltipTitle]="'Valor de referencia: ' + form.get('phosphorus').get('reference').get('min').value + ' a ' + form.get('phosphorus').get('reference').get('max').value + ' ' + form.get('phosphorus').get('unit').value" nzTooltipPlacement="top" nz-tooltip>
        <div class="tw-mb-3 tw-flex tw-items-start tw-justify-between">
          Fosforo
          <ng-container *ngIf="(form.get('phosphorus') | getLevelBiochemical) as inferenceValue">
            <p  *ngIf="inferenceValue.value > 0 && inferenceValue.difference" class="option-item-warning">
            <i *ngIf="inferenceValue.value > 0" nz-icon nzType="info-circle" nzTheme="outline" class="tw-mr-2"></i>{{ inferenceValue.inference }}
          </p>
          </ng-container>
        </div>
        <nz-input-group [nzAddOnAfter]="form.get('phosphorus').get('unit').value">
          <nz-input-number [nzMin]="0" formControlName="value" type="text" nz-input ></nz-input-number>
        </nz-input-group>
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-end tw-mt-7">
    <button nz-button nzType="primary" (click)="onSave();" *ngIf="!(this.isPatient$ | async)">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      Guardar
    </button>
  </div>
</ng-container>
